"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationService = void 0;
const VerificationServiceStub_1 = require("./VerificationServiceStub");
const VerificationServiceLive_1 = require("./VerificationServiceLive");
class VerificationService {
    static create(stub) {
        if (stub) {
            return new VerificationServiceStub_1.VerificationServiceStub();
        }
        return new VerificationServiceLive_1.VerificationServiceLive();
    }
}
exports.VerificationService = VerificationService;
//# sourceMappingURL=VerificationService.js.map